import React,{ useState,useEffect}from 'react'
import { Modal,Form,App, Input} from 'antd';
import { useBnsXiangMuBanBenAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import UploadOne from '../../cpn/UploadOne';
import ClientSelect from '../client/ClientSelect';
import ModuleSelect from '../module/ModuleSelect';
const { TextArea } = Input;
function SketchAddCopy(props) {   
    const {message} = App.useApp() 
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsXiangMuBanBenAddMutation()
    const [info,setInfo] = useState({
        'bxmbb_bxm_id': props.bxm_id,
        'bxmbb_bxm_name': props.bxm_name,
        'bxmbb_cid': props.eu_id,
        'bxmbb_cname': props.eu_name,
        'bxmbb_name': props.bxmbb_name,
        'bxmbb_content': props.bxmbb_content,
        'bxmbb_image': props.bxmbb_image,
        bxmbb_yh_id:props.yh_id,
        bxmbb_yh_name:props.yh_name,  
        bxmbb_xq_id:props.bxmxq_id,
        bxmbb_xq_name:props.bxmxq_name,
    });
    useEffect(() => {
        if(props && open){
            form.setFieldsValue({
                bxmbb_name:props.bxmbb_name,
                bxmbb_content:props.bxmbb_content,  
                bxmbb_image:props.bxmbb_image,
            })            
        }
    },[props,open,form])
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined />  复制新增</a>
                <Modal
                    width={1000}
                    open={open}
                    title='新增效果图'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add(info).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_sketch_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <ClientSelect
                            name="bxmbb_cid"
                            label="客户端"
                            wrapperCol={{ span: 20 }}
                            onChange={(e,f) => {
                                setInfo(prevState => ({ ...prevState, bxmbb_yh_id: e, bxmbb_yh_name: f }))
                            }}
                            style={{ width: '200px' }}
                            bxm_id={props.bxm_id}
                            bxm_name={props.bxm_name}
                            eu_id={props.eu_id}
                            eu_name={props.eu_name}
                        />
                        <ModuleSelect
                            name="bxmbb_xq_id"
                            label="模块"
                            wrapperCol={{ span: 20 }}
                            onChange={(e,f) => {
                                setInfo(prevState => ({ ...prevState, bxmbb_xq_id: e, bxmbb_xq_name: f }))
                            }}
                            style={{ width: '200px' }}
                            bxm_id={props.bxm_id}
                            bxm_name={props.bxm_name}
                            eu_id={props.eu_id}
                            eu_name={props.eu_name}
                            bxmxq_id={props.bxmxq_id}
                            bxmxq_name={props.bxmxq_name}
                            yh_id={info.bxmbb_yh_id}
                            yh_name={info.bxmbb_yh_name}
                        />
                        <Form.Item
                            name="bxmbb_name"
                            label="名称"
                            wrapperCol={{ span: 20 }}
                        >
                            <Input
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, bxmbb_name: e.target.value }))
                                }}
                            />
                        </Form.Item>
                        <UploadOne
                            fileStr={(fileStr) => { setInfo(prevState => ({ ...prevState, bxmbb_image: fileStr })) }} 
                            label="效果图"
                            name="bxmbb_image"
                            maxCount={1}
                            defaultFileList={[{uid:props.bxmbb_image,name:props.bxmbb_name,url:`/api/assets/images/application/${props.bxmbb_image}`}]}
                        />
                        <Form.Item
                            name="bxmbb_content"
                            label="备注"
                            wrapperCol={{ span: 20 }}
                        >
                            <TextArea
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, bxmbb_content: e.target.value }))
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
}

export default SketchAddCopy
